/**
 * Các field tìm kiếm chứng từ
 */
export default  {
  JusticeDecision: 'justice_decision_id',
  // JusticeDecisionType: 'justice_decision_type_id',
  Executor: 'executor_id',
  RefDate: 'ref_date',
  RefNo: 'ref_no',
  RefType: 'ref_type',
  PostedDate: 'posted_date',
  DebitAccount: 'debit_account',
  CreditAccount: 'credit_account',
  Amount: 'amount',
  Object: 'object_id',
  Quantity: 'quantity',
  Stock: 'stock_id',
  Description: 'description',
  Asset: 'asset_id',
  OrgVoucherDate: 'org_voucher_date',
  OrgVoucherNo: 'org_voucher_no',
  Currency: 'currency_code',
  Statistic: 'list_code_alias',
  JusticeCase: 'justice_case_id',
  ValueType: 'value_type_id',
  Area: 'area_id',
};